// extracted by mini-css-extract-plugin
module.exports = {"root":"MeatballsMenu_root__HSA6y","button":"MeatballsMenu_button__1Ducy"};